import { Guid } from '../guid';
import { MapperBase } from '../../utilities/mapper-base';
import { UserResource } from '../resource/user.resource';
import { User } from '../ui/user.model';
import { uniqBy, orderBy } from 'lodash-es';
import { UserRoleResourceToRoleMapper } from './user-role-resource-to-role.mapper';
import { AccountResourceToAccountMapper } from './account-resource-to-account.mapper';
import { CaseResourceToLexbeCaseMapper } from './case-resource-to-lexbe-case.mapper';

export class UserResourceToUserMapper extends MapperBase<UserResource, User> {
	map(source: UserResource): User {
		const dest = new User();
		const mapper = new UserRoleResourceToRoleMapper();
		const accountMapper = new AccountResourceToAccountMapper();
		const caseMapper = new CaseResourceToLexbeCaseMapper();
		dest.id = source?.id ?? Guid.Empty;
		dest.userName = source?.userName ?? '';
		dest.phoneNumber = source?.phoneNumber ?? '';
		dest.email = source?.email ?? '';
		dest.emailConfirmed = source?.emailConfirmed ?? false;
		dest.phoneNumberConfirmed = source?.phoneNumberConfirmed ?? false;
		dest.twoFactorEnabled = source?.twoFactorEnabled ?? false;
		dest.roles = mapper.mapCollection(source?.roles);
		dest.createDate = source?.createDate ?? '';
		dest.lastActivityDate = source?.lastActivityDate ?? '';
		dest.lastLoginDate = source?.lastLoginDate ?? '';
		dest.accounts = orderBy(uniqBy(accountMapper.mapCollection(source?.accounts), 'accountId'), 'accountName', 'asc');
		dest.cases = orderBy(caseMapper.mapCollection(source?.cases), 'caseName', 'asc');
		return dest;
	}

}
